import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/outline';
import { memo } from 'react';
import {
  Pagination as HeadlessPagination,
  NextButton,
  PageButton,
  PrevButton,
} from 'react-headless-pagination';

const Pagination = ({
  currentPage,
  setCurrentPage,
  totalPages,
  middlePagesSiblingCount = 1,
}) => {
  return (
    <div className="mt-4 pb-10">
      {totalPages > 1 && (
        <HeadlessPagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          edgePageCount={2}
          middlePagesSiblingCount={middlePagesSiblingCount}
          truncableClassName="hidden sm:block w-10 px-0.5 text-center"
          truncableText="..."
          className="flex items-center justify-between gap-x-3"
        >
          <PrevButton className="bg-white rounded-full text-gray-600 p-3  disabled:text-gray-400">
            <ArrowLeftIcon className="h-4 w-4" />
            <div className="sr-only">Previous</div>
          </PrevButton>

          <ul className="flex items-center justify-center">
            <PageButton
              activeClassName="bg-neutral-200 text-primary-700 font-bold !text-gray-900 text-white"
              className="sm:flex h-11 w-11 hidden cursor-pointer sm:items-center sm:justify-center rounded-full text-sm"
              inactiveClassName="text-gray-500"
            />
          </ul>

          <NextButton className="bg-white rounded-full text-gray-600 p-3  disabled:text-gray-400">
            <div className="sr-only">Next</div>
            <ArrowRightIcon className="h-4 w-4" />
          </NextButton>
        </HeadlessPagination>
      )}
    </div>
  );
};

export default memo(Pagination);
